"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _thirdOrderApi = require("@/api/thirdOrderApi.js");
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _static = require("../static");
var pintuanApi = _interopRequireWildcard(require("@/api/pintuanApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'thirdOrderDetail',
  components: {},
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      orderStateOption: _static.orderStateOption,
      dialogVisible: false,
      orderDatalist: {},
      id: null,
      logLists: [],
      // 日志列表
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      constants: this.$constants,
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      formData: {},
      timeVal: [],
      listDataNew: {}
    };
  },
  mounted: function mounted() {},
  methods: {
    transformState: _transformState.default,
    openDetail: function openDetail(id) {
      this.id = id;
      if (!id) {
        this.$message.warning('未查询到该订单！');
        return;
      }
      this.handleTimer();
      this.getOrderData();
    },
    getOrderData: function getOrderData() {
      var _this = this;
      (0, _thirdOrderApi.getDetail)(this.id).then(function (res) {
        _this.formData = res;
      });
      this.dialogVisible = true;
      this.handleSrsht();
    },
    handleSrsht: function handleSrsht() {
      var _this2 = this;
      (0, _thirdOrderApi.getLogDetail)(_objectSpread(_objectSpread({
        pinkId: this.id
      }, this.listPram), {}, {
        dateLimit: this.timeVal.join(',')
      })).then(function (res) {
        _this2.listDataNew = res;
        _this2.listLoading = false;
      });
    },
    handleTimer: function handleTimer() {
      // 获取当前日期
      var today = new Date();
      var startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - 7);

      // 格式化日期为 yyyy-MM-dd
      var formatDate = function formatDate(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
      };
      var startDate = formatDate(startOfWeek);
      var endDate = formatDate(today);
      this.timeVal = [startDate, endDate];
    },
    onchangeTime: function onchangeTime(value) {
      this.timeVal = value;
      this.handleSrsht();
    },
    // 关闭弹窗，判断是否需要刷新列表
    handleColse: function handleColse() {
      this.dialogVisible = false;
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this3 = this;
      this.listLoading = true;
      (0, _thirdOrderApi.getLogDetail)(_objectSpread(_objectSpread({
        pinkId: this.id
      }, this.listPram), {}, {
        dateLimit: this.timeVal.join(',')
      })).then(function (res) {
        console.log(res, '21111');
        _this3.listDataNew = res;
      });
      this.listLoading = false;
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    }
  }
};